document.addEventListener('DOMContentLoaded', () => {

    // Controllo se è Firefox
    const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    
    // Attiviamo le animazioni solo se NON è Firefox
    if (!isFirefox) {
        document.body.classList.add('animations-enabled');
        
        // Animate elements on scroll
        const animatedElements = document.querySelectorAll('.product-card, .ambient-card');
        
        if (animatedElements.length > 0) {
            const animationObserver = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('is-visible');
                        animationObserver.unobserve(entry.target);
                    }
                });
            }, {
                threshold: 0.1
            });

            animatedElements.forEach(element => {
                animationObserver.observe(element);
            });

            // Fallback: assicurati che siano visibili dopo 2s in ogni caso
            setTimeout(() => {
                animatedElements.forEach(el => el.classList.add('is-visible'));
            }, 2000);
        }
    } else {
        // Su Firefox, mostriamo tutto subito per sicurezza
        const animatedElements = document.querySelectorAll('.product-card, .ambient-card');
        animatedElements.forEach(el => el.classList.add('is-visible'));
    }

    // Initialize sliders (funzionano su tutti i browser)
    const sliders = document.querySelectorAll('.slider-wrapper');
    sliders.forEach(wrapper => {
        const slider = wrapper.querySelector('.featured-product-grid');
        const prevBtn = wrapper.querySelector('.prev-slide');
        const nextBtn = wrapper.querySelector('.next-slide');

        if (!slider || !prevBtn || !nextBtn) return;

        let scrollHandler;
        let nextClickHandler;
        let prevClickHandler;
        let resizeHandler;
        
        const initSlider = () => {
            if (scrollHandler) slider.removeEventListener('scroll', scrollHandler);
            if (nextClickHandler) nextBtn.removeEventListener('click', nextClickHandler);
            if (prevClickHandler) prevBtn.removeEventListener('click', prevClickHandler);

            if (window.matchMedia("(max-width: 768px)").matches) {

                const slideWidth = () => slider.querySelector('.featured-product-card')?.clientWidth ?? 0;
                
                const updateButtons = () => {
                    const scrollLeft = Math.round(slider.scrollLeft);
                    const scrollWidth = slider.scrollWidth;
                    const clientWidth = slider.clientWidth;
                    const isAtEnd = scrollLeft + clientWidth >= scrollWidth - 15;

                    const tolerance = 15;
                    prevBtn.classList.toggle('is-hidden', scrollLeft <= tolerance);
                    nextBtn.classList.toggle('is-hidden', isAtEnd);
                };

                let scrollTimeout;
                scrollHandler = () => {
                    clearTimeout(scrollTimeout);
                    scrollTimeout = setTimeout(updateButtons, 50);
                };

                nextClickHandler = () => slider.scrollBy({ left: slideWidth() + 15, behavior: 'smooth' });
                prevClickHandler = () => slider.scrollBy({ left: -(slideWidth() + 15), behavior: 'smooth' });

                slider.addEventListener('scroll', scrollHandler);
                nextBtn.addEventListener('click', nextClickHandler);
                prevBtn.addEventListener('click', prevClickHandler);

                updateButtons();
            } else {
                prevBtn.classList.remove('is-hidden');
                nextBtn.classList.remove('is-hidden');
            }
        };

        resizeHandler = () => {
            let resizeTimeout;
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(initSlider, 250);
        };

        initSlider();
        window.addEventListener('resize', resizeHandler);
    });
});
